import React from 'react'
import Chip from '@mui/material/Chip'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const AutocompleteChip = ({ label, placeholder, options, defaultValue, value, onChange, disableNewOption = false }) => (
  <Container>
    <Autocomplete
      value={value}
      onChange={(_, value) => onChange(value)}
      multiple
      options={options}
      defaultValue={defaultValue}
      freeSolo={!disableNewOption}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip label={option} {...getTagProps({ index })} />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} variant="standard" label={label} placeholder={placeholder} />
      )}
    />
    {!disableNewOption && (
      <Typography variant="caption">Press ENTER to add a new option</Typography>
    )}
  </Container>
);

export default AutocompleteChip
